import actionTypes from '../../constants/actions/importarLineasPedidosExcel/importarLineasPedidosExcel'

export function initialState () {
  return {
    showModalImportarLineasPedidosExcel: false,
    archivoExcel: [],
    listImportarLineasPedidosExcel: []
  }
}

export function abrirModalImportarLineasPedidosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarLineasPedidosExcel: true
  }
}

export function cerrarModalImportarLineasPedidosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarLineasPedidosExcel: false,
    archivoExcel: [],
    listImportarLineasPedidosExcel: []
  }
}

export function subirArchivosImportarLineasPedidosExcel (state, {archivoExcel}) {
  return {
    ...state,
    archivoExcel: archivoExcel
  }
}

export function submitImportarLineasPedidosExcelSuccess (state, {listImportarLineasPedidosExcel}) {
  return {
    ...state,
    listImportarLineasPedidosExcel: listImportarLineasPedidosExcel
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.ABRIR_MODAL_IMPORTAR_LINEAS_PEDIDOS_EXCEL:
      return abrirModalImportarLineasPedidosExcel(state, action)
     case actionTypes.CERRAR_MODAL_IMPORTAR_LINEAS_PEDIDOS_EXCEL:
      return cerrarModalImportarLineasPedidosExcel(state, action)
     case actionTypes.SUBIR_ARCHIVOS_IMPORTAR_LINEAS_PEDIDOS_EXCEL:
      return subirArchivosImportarLineasPedidosExcel(state, action)
     case actionTypes.SUBMIT_IMPORTAR_LINEAS_PEDIDOS_EXCEL_SUCCESS:
      return submitImportarLineasPedidosExcelSuccess(state, action)
    default:
      return state
  }
}
